import { render, staticRenderFns } from "./businesses.vue?vue&type=template&id=1fe799dc&scoped=true"
import script from "./businesses.vue?vue&type=script&lang=js"
export * from "./businesses.vue?vue&type=script&lang=js"
import style0 from "./businesses.vue?vue&type=style&index=0&id=1fe799dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe799dc",
  null
  
)

export default component.exports